import { createFileRoute } from "@tanstack/react-router";
import { ShieldCheck, Check } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import {
  PRIVACY_INTRO_BULLETS,
  PRIVACY_LAST_UPDATED,
  PRIVACY_SECTIONS,
} from "@/lib/legal-copy";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — SmartEssay.ai" },
      {
        name: "description",
        content:
          "SmartEssay.ai Privacy Policy. We never train on your essays without consent, encrypt your data, and never sell it. FERPA and COPPA aware.",
      },
      { property: "og:title", content: "Privacy Policy — SmartEssay.ai" },
      {
        property: "og:description",
        content: "How SmartEssay collects, uses, and protects your data.",
      },
      { property: "og:url", content: "https://smartessay.ai/privacy" },
    ],
    links: [{ rel: "canonical", href: "https://smartessay.ai/privacy" }],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <div className="min-h-screen bg-hero-gradient">
      <SiteHeader />

      <main className="mx-auto max-w-3xl px-6 pb-24">
        <div className="text-center">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
            <ShieldCheck className="h-7 w-7 text-primary" />
          </div>
          <h1 className="mt-4 font-display text-3xl font-semibold tracking-tight sm:text-4xl">
            Privacy Policy
          </h1>
          <p className="mx-auto mt-2 max-w-xl text-sm text-muted-foreground">
            Last updated: {PRIVACY_LAST_UPDATED}
          </p>
        </div>

        <div className="mt-10 rounded-2xl border-2 border-primary/30 bg-primary/5 p-6 shadow-soft sm:p-8">
          <h2 className="flex items-center gap-2 font-display text-xl font-semibold">
            <ShieldCheck className="h-5 w-5 text-primary" />
            We take your data seriously
          </h2>
          <ul className="mt-4 space-y-2 text-sm">
            {PRIVACY_INTRO_BULLETS.map((b) => (
              <li key={b} className="flex items-start gap-2 text-foreground">
                <Check className="mt-0.5 h-4 w-4 flex-none text-primary" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-12 space-y-10">
          {PRIVACY_SECTIONS.map((s) => (
            <section key={s.title} id={s.id} className="scroll-mt-24">
              <h2 className="font-display text-2xl font-semibold tracking-tight">
                {s.title}
              </h2>
              <div className="mt-3 space-y-3 text-sm leading-relaxed text-muted-foreground">
                {s.body.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>

    </div>
  );
}
